import { Logo } from "components";
import { ComponentProps } from "react";
import { Fragment } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";
import { ChildrenProps } from "types";

type LayoutHeaderProps = {
  divProps?: Omit<ComponentProps<"div">, "children">;
} & Omit<ComponentProps<"header">, "divProps">;

function Layout({ children }: ChildrenProps) {
  return <Fragment>{children}</Fragment>;
}
function LayoutHeader({
  divProps = {},
  className,
  children,
  ...props
}: LayoutHeaderProps) {
  return (
    <header
      className={twMerge("bg-theme sticky top-0 w-full z-10", className)}
      {...props}
    >
      <div
        {...divProps}
        className={twMerge(
          "w-full pt-[1.875rem] max-w-screen-sm mx-auto px-5",
          divProps.className,
        )}
      >
        {children}
      </div>
    </header>
  );
}
function LayoutBody({ className, children, ...props }: ComponentProps<"main">) {
  return (
    <main
      className={twMerge(
        "w-full min-h-[calc(100svh-11.625rem)] py-4 px-5 max-w-screen-sm mx-auto",
        className,
      )}
      {...props}
    >
      {children}
    </main>
  );
}
function LayoutFooter() {
  return (
    <footer className="w-full px-5 pb-10 space-y-1 max-w-screen-sm mx-auto">
      <hr className="w-full" />
      <p className="w-full text-center text-[#3D3F4E] text-xs font-medium !mt-3">
        Created by
      </p>
      <Logo variant="logo-team-dark" className="block w-40 mx-auto" />
      <p className="w-full text-center text-xs text-[#3D3F4E] font-medium">
        Copyright © 2026 Gataa studio
      </p>
    </footer>
  );
}

Layout.Header = LayoutHeader;
Layout.Body = LayoutBody;
Layout.Footer = LayoutFooter;

export default Layout;
